<template>
    <div class="bi-content-dataprogressbarconfig">
        <div class="bi-content-top">
            <div class="opera-tit-btn">
                <div class="btn">
                    <el-radio-group v-model="progressBarType" class="btn-group">
                      <el-radio-button label="1">条形</el-radio-button>
                      <el-radio-button label="2">环形</el-radio-button>
                    </el-radio-group>
                    <el-button type="primary" @click="saveData">保存配置</el-button>
                </div>
            </div>
            <div class="form-data">
                <el-form class="float:left" size="mini" label-width="100px">
                    <el-row>
                        <el-col :span="4">
                          <el-form-item label="数据来源">
                                <el-radio v-model="BIDimension" :label="0" @change="initFormList" :disabled="canChoose">表单</el-radio>
                                <el-radio v-model="BIDimension" :label="2" @change="initFormList" :disabled="canChoose">报表</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="数据源">
                                 <TreeSelect
                                     placeholder="请选择数据源"
                                     ref="treeSelect"
                                     :multiple="false"
                                     :disableBranchNodes="true"
                                     :sourceOptions="appModelsOptions"
                                     @treeSelectChoose="treeSelectChoose"
                                 />
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item label="纬度">
                               <el-select v-model="selectXdata" :disabled="isCanSelect" clearable placeholder="请选择需要分类的字段" @change="changeXdata"  style="width: 100%;">
                                   <el-option
                                       v-for="(item, index) in XData"
                                       :key="index"
                                       :label="BIDimension === 2 ? '【' + item.formName + '】' + item.name : item.name"
                                       :value="item.id"
                                   ></el-option>
                               </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="指标字段">
                              <el-select
                                  v-model="selectYdata"
                                  :disabled="isCanSelect"
                                  value-key="id"
                                  clearable
                                  placeholder="请选择需要分组统计的字段"
                                  @change="changeYdata"
                                  :multiple="yIsmultiple"
                                  style="width: 100%;"
                              >
                                  <el-option
                                      v-for="item in YData"
                                      :key="item.id"
                                      :label="BIDimension === 2 ? '【' + item.formName + '】' + item.name : item.name"
                                      :value="item.id"
                                  ></el-option>
                              </el-select>
                          </el-form-item>
                        </el-col>
                     </el-row>
                     <el-row v-if="allChooseYdata.length>0">
                        <div class="zb-item" v-for="(item,index) in allChooseYdata" :key="index">
                            <div class="item-field">计算方式</div>
                            <div class="item-calcul">
                                <el-select v-model="item.calculVal"  value-key="id" placeholder="请选择计算方式">
                                    <el-option v-for="i in opreaYdata" :key="i.id" :label="i.name" :value="i.id" v-if="i.showType==item.showType"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item-field-search">
                            <div class="item-field-search-bun">
                                <span @click="chooseConditionFields()">过滤条件</span>
                            </div>
                            <div class="item-field-search-content" v-if="showConditionFields">
                                <div class="item-field-search-content-box">
                                    <SearchCondition
                                        ref="searchConditon"
                                        :conditionFields="conditionFields"
                                        :isShowLeftModel="false"
                                        :class="'search-field-box'"
                                        :style="'height:60vh;overflow:auto;'"
                                        :key="loadtimeSearch"
                                        >
                                    </SearchCondition>
                                </div>
                                <div class="item-field-search-content-btn">
                                    <el-button @click="celSetForm()">取消</el-button>
                                    <el-button type="success" @click="subSetForm()">确定</el-button>
                                </div>
                            </div>
                        </div>
                     </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { getApplicationModelTreeList, getBIFormConfigs, getModelFormReportList, getFormFieldListByIds } from '@/data-model';
import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
import { isEmpty } from 'lodash';
export default {
    components: {
        SearchConditionSide: SearchConditionSide
    },
    props: {
        biConfigData: {
            type: Object,
            default: () => {
                return {
                    modelTit: '',
                    appId: '',
                    formId: '',
                    modelName: '',
                    remarks: '',
                    modelId: ''
                };
            }
        },
        dataProgressBarConfig: {
            type: Object
        }
    },
    data () {
        return {
            appModelsOptions: [],
            XData: [],
            YData: [],
            searchData: [],
            opreaYdata: [{id: 1, name: '原值显示', showType: 0}, {id: 3, name: '加和统计', showType: 1}],
            cakeData: [],
            selectXdata: '',
            selectYdata: '',
            selectSearchData: [],
            selectOpreaYdata: '',
            selectCakedata: '',
            isCanSelect: true,
            formData: {},
            BIDimension: 0,
            chartSettings: {},
            dashboardSetting: {},
            modelId: '',
            allChooseXdata: {},
            allChooseYdata: [],
            formId: '',
            initData: 0,
            id: '',
            yIsmultiple: false,
            canChoose: false,
            showDataSource: '0',
            showConditionFields: false,
            conditionFields: [],
            loadtimeSearch: '',
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 3, // 每页条数
                totalPageNum: 0 // 总页数
            },
            progressBarType: 1

        };
    },
    created () {
        this._initPage();
    },
    methods: {
        async _initPage () {
            let param = {
			    currentPage: 1,
			    pageSize: 100,
			    state: 1,
			    modelType: this.BIDimension
            };
            if (this.BIDimension < 2) {
			    param.aopModelType = 1;
            }
            let modelTree = await getApplicationModelTreeList(param);
            this.appModelsOptions = modelTree;
            if (!isEmpty(this.dataProgressBarConfig)) { // 修改
                this.$refs.treeSelect.initParam(this.dataProgressBarConfig.dataModelId);
                this.initData = 1;
                let o = JSON.parse(this.dataProgressBarConfig.dashboardSetting);
                this.selectYdata = o.fieldIds[0];
                this.selectXdata = o.groupField.id;
                this.allChooseXdata = o.groupField;
                this.allChooseYdata = [];
                this.progressBarType = this.dataProgressBarConfig.progressBarType;
                for (let i = 0; i < o.fieldIds.length; i++) {
                    let showType = 0;
                    if (o.fieldType[i] === 'number') {
                        showType = 1;
                    }
                    let currentData = { id: o.fieldIds[i], name: o.field[i], type: o.fieldType[i], calculVal: o.calculVal[i], alias: o.alias[i], showType: showType };
                    this.allChooseYdata.push(currentData);
                }
                this.conditionFields = this.dataProgressBarConfig.conditionFields;
                this.modelId = this.dataProgressBarConfig.modelId;
            }
        },
        initFormList () {
            this._initPage();
        },
        initSelectData () {
            this.selectXdata = '';
            this.selectYdata = '';
            this.selectCakedata = '';
        },
        treeSelectChoose (selected) {
            // 选择好数据源后
            if (selected) {
                this.formId = selected.formId;
                this.modelId = selected.id;
                this.initField(selected);
                if (this.initData === 0) {
                    this.initSelectData();
                } else {
                    this.initData = 0;
                }
            } else {
                this.formData = {};
                this.isCanSelect = true;
                this.selectXdata = '';
                this.selectYdata = '';
                this.searchData = '';
            }
        },
        async initField (selected) {
            var param = { formId: selected.formId, BIDimension: this.BIDimension };
            let field = await getBIFormConfigs(param);
            this.isCanSelect = false; // 解锁字段展现列表
            this.XData = field.allList;
            this.YData = field.allList;
            this.searchData = field.allList;
            this.cakeData = field.allList;
            this.formData = selected;
        },
        changeYdata (e) {
            this.catchYData = this.allChooseYdata;
            this.allChooseYdata = [];
            if (e instanceof Array) {
                for (var j = 0; j < e.length; j++) {
                    let yobj = this.catchYData.find(y => y.id === e[j]);
                    if (yobj) {
                        this.allChooseYdata.push(yobj);
                    } else {
                        let list = this.YData.find(i => i.id === e[j]);
                        let showType = 0;
                        if (list.type === 'number') {
                            showType = 1;
                        }
                        let currentData = { id: e[j], name: list.name, type: list.type, calculVal: '', alias: '', showType: showType };
                        this.allChooseYdata.push(currentData);
                    }
                }
            } else {
                let list = this.YData.find(i => i.id === e);
                let showType = 0;
                if (list.type === 'number') {
                    showType = 1;
                }
                let currentData = { id: e, name: list.name, type: list.type, calculVal: '', alias: '', showType: showType };
                this.allChooseYdata.push(currentData);
            }
        },
        changeXdata (e) {
            // 拿到X轴的数据,然后更新展示数据,目前X轴就一条数据后期多了再改造
            let list = this.XData.find(i => i.id === e);
            let currentData = { id: e, name: list.name, type: list.type };
            this.allChooseXdata = currentData;
        },
        buildParams () {
            // 参数统一在此构造
            let param = {};
            let dashboardSetting = {};
            dashboardSetting.field = [];
            dashboardSetting.fieldIds = [];
            dashboardSetting.fieldType = [];
            dashboardSetting.calculVal = [];// 计算规则
            dashboardSetting.alias = [];// 别名
            dashboardSetting.groupField = this.allChooseXdata;
            for (var i = 0; i < this.allChooseYdata.length; i++) {
                var name = this.allChooseYdata[i].name;
                var id = this.allChooseYdata[i].id;
                var type = this.allChooseYdata[i].type;
                var calculVal = this.allChooseYdata[i].calculVal;// 计算规则
                if (!calculVal || calculVal === '') {
                    calculVal = 2;
                }
                var alias = this.allChooseYdata[i].alias;// 别名
                if (!alias || alias === '') {
                    alias = name;
                }
                dashboardSetting.field.push(name);
                dashboardSetting.fieldIds.push(id);
                dashboardSetting.fieldType.push(type);
                dashboardSetting.calculVal.push(calculVal);
                dashboardSetting.alias.push(alias);
            }
            param.dashboardSetting = JSON.stringify(dashboardSetting);
            param.dataFormId = this.formId;
            param.dataModelId = this.modelId;
            param.modelType = this.BIDimension;
            param.conditionFields = JSON.stringify(this.conditionFields);
            param.progressBarType = this.progressBarType;
            return param;
        },
        saveData () {
            let biData = this.buildParams();
            this.$emit('configDataProgressBar', biData);
        },
        chooseConditionFields () {
            let param = {dataModelId: this.modelId, dataFormId: this.formId};
            this.renderFormList(param, true, null);
        },
        async renderFormList (model, isInitSearch, searchCondition) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            let tcln = [];
            if (formData.otherData && formData.otherData.tableColumns) {
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        tcln.push(item);
                    }
                });
            }
            this.refreshSearchConditon(tcln);
            loading.close();
        },
        async refreshSearchConditon (columns) {
            let rtArr = [];
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        rtArr.push(cfs[i]);
                    }
                }
            }
            this.conditionFields = rtArr;
            this.showConditionFields = true;
            this.loadtimeSearch = new Date().getTime();
        },
        celSetForm () {
            this.conditionFields = [];
            this.showConditionFields = false;
        },
        subSetForm () {
            this.showConditionFields = false;
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.bi-content-dataprogressbarconfig {
    // border: 1px solid #d6d4d7;
    height: 99%;
    width: 96%;
    top: 0vh;
    overflow: auto;
    position: absolute;
    .bi-content-top{
        .opera-tit-btn{
            display: flex;
            height:6vh;
            line-height: 6vh;
            .tit{
                flex: 1;
                font-size: 1.25rem;
                font-weight: 400;
                text-align: left;
            }
            .btn{
                flex: 1;
                text-align: right;
                .btn-group{
                    margin-right: 20px;
                }
            }
        }
        .form-data{
            .zb-item{
                display: flex;
                width: 300px;
                height: 40px;
                line-height: 40px;
                margin-left: 20px;
                float: left;
                border: 2px dashed #bbb5b5;
                margin-bottom: 6px;
                .item-field{
                   width:90px;
                   display: flex;
                   .field-name{
                       display: inline-block;
                       text-overflow: ellipsis;
                       white-space: nowrap;
                       overflow: hidden;
                       cursor: pointer;
                   }
                   .field-name-border{
                       display: inline-block;
                   }
                }
                .item-calcul{
                   width: 190px;
                }
                .item-alias{
                   width: 190px;
                }
            }
            .item-field-search{
                margin-left: 10px;
                position: relative;
                width: 200px;
                float: left;
                height: 40px;
                line-height: 40px;
                .item-field-search-bun{
                   margin-left: 10px;
                   color: #409eff;
                   span{
                       cursor: pointer;
                   }
                }
                .item-field-search-content{
                    position: absolute;
                    z-index: 111;
                    .el-tabs__content{
                        z-index: 333;
                    }
                }
            }
            .bi-type{
                display: flex;
                padding-left: 32px;
               .bi-type-item {
                   width: 58px;
                   height: 60px;
                   line-height: 60px;
                   float: left;
                   text-align: center;
                   img {
                       width: 30px;
                       height: 30px;
                       cursor: pointer;
                       margin-top: 10px;
                       padding: 5px;
                   }
                   img:hover {
                       width: 40px;
                       height: 40px;
                   }
                   .active {
                       border: 2px solid #009ed0;
                   }
               }
               .bi-tit{
                   width: 60px;
                   height: 60px;
                   line-height: 60px;
               }
               .bi-datasource-tit{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
               .bi-datasource-data{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
            }
        }
    }
    .bi-content-main{
        margin-top: 1vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DataProgressBarConfig.vue